<template>
  <!-- Footer -->
  <footer id="footer" class="footer mt-30">
    <div class="container pt-40 pb-40">
      <div class="row border-bottom-black">
        <div class="col-sm-12 col-md-12 col-lg-4 pb-70">
          <div class="widget dark">
            <img
              class="mt-10 mb-20 logo-uii-footer"
              alt
              src="../assets/logo.png"
            />
            <p class="desc-footer">
              Rumah Sakit UII adalah rumah sakit di Yogyakarta yang mempunyai
              layanan yang berfokus pada pasien, sehingga pasien adalah yang
              utama.
            </p>
            <ul class="mt-5 info-footer">
              <li class="m-0 pl-0 pr-10 relative">
                <i class="fa fa-hospital-o text-theme-colored mr-5"></i>
                <span
                  >Jl. Srandakan Km. 5,5, Pandak, Bantul. D.I Yogyakarta
                  55761</span
                >
              </li>
              <li class="m-0 pl-0 pr-10">
                <i class="fa fa-ambulance text-theme-colored mr-5"></i> IGD Buka
                24 Jam, Tlp: 281-2111
              </li>
              <li class="m-0 pl-0 pr-10">
                <i class="fa fa-phone text-theme-colored mr-5"></i> (0274)
                2812-999
              </li>
              <li class="m-0 pl-0 pr-10">
                <i class="fa fa-envelope-o text-theme-colored mr-5"></i>
                <a href="mailto:contact@rsuii.co.id">contact@rsuii.co.id</a>
              </li>
            </ul>
            <div ref="container"></div>
          </div>
        </div>
        <div class="col-md-12 col-lg-1 col-sm-12"></div>
        <div class="col-sm-12 col-md-12 col-lg-3 pb-70">
          <div class="widget dark">
            <h4 class="widget-title">Link Terkait</h4>
            <ul class="list-border">
              <li>
                <b-link :to="{ path: '/' }">Beranda</b-link>
              </li>
              <li>
                <b-link :to="{ path: '/about-us' }">Tentang Kami</b-link>
              </li>
              <li>
                <b-link :to="{ path: '/jadwal-dokter' }">Jadwal Dokter</b-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4 pb-40">
          <div class="widget dark">
            <h4 class="widget-title">Lokasi RS UII</h4>
            <div class="opening-hours">
              <iframe
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?q=Rumah%20Sakit%20UII&amp;t=m&amp;z=14&amp;output=embed&amp;iwloc=near"
                aria-label="Rumah Sakit UII"
                style="width: 100%; height: 250px"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container pt-20 footer-bottom-container">
        <div class="row">
          <div class="col-md-6 copyright">
            <p class="font-13 text-black-777 m-0">
              Copyright &copy; PT. Unisia Edu Medika
            </p>
          </div>
          <div class="col-md-6 text-right soc-med">
            <div class="widget no-border m-0">
              <ul class="styled-icons icon-dark icon-circled icon-sm">
                <li>
                  <a
                    href="https://www.facebook.com/rumahsakit.uii"
                    target="_blank"
                  >
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/rumahsakit.uii"
                    target="_blank"
                  >
                    <i class="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://t.me/HealthTalkRSUII" target="_blank">
                    <i class="fa fa-telegram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  mounted() {
    // Create a new script element\
    const hrefStartsWith = "https://www.freevisitorcounters.com";
    const elements = document.querySelectorAll(`[href^="${hrefStartsWith}"]`);
    if (elements.length > 0) {
      // Move each element to a new position in the DOM
      elements.forEach(element => {
        this.$refs.container.appendChild(element);
      });
    }
    // const counterImage = document.querySelector(".counterimg");
    // this.$refs.container.appendChild(counterImage);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue